import * as yup from "yup";

export const resetPasswordSchema = yup.object({
  email: yup.string().email().required(),
  otp: yup.string().required(),
  password: yup
    .string()
    .min(8, ({ min }) => `Password must be at least ${min} characters`)
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[#?!@$%^&*-]).{8,}$/,
      () => "Please Enter a valid password"
    )
    .required("Password is required"),
});

export type resetPasswordType = yup.InferType<typeof resetPasswordSchema>;
